import React from 'react';
import { Box, Typography } from '@mui/material';

type StatCardProps = {
  value: number;
  label: string;
};

const StatCard = ({ value, label }: StatCardProps) => (
  <Box className="stat-card">
    <Typography variant="h6">{value}</Typography>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

type StatsSummaryProps = {
  visitors: number;
  loggedIn: number;
  loggedOut: number;
  puzzleOpens: number;
  puzzleSolves: number;
};

export const StatsSummary = ({ visitors, loggedIn, loggedOut, puzzleOpens, puzzleSolves }: StatsSummaryProps) => {
  return (
    <Box className="stats-summary" mb={3}>
      <StatCard value={visitors} label="Visitors Today" />
      <StatCard value={loggedIn} label="Logged In Today" />
      <StatCard value={loggedOut} label="Logged Out Today" />
      <StatCard value={puzzleOpens} label="Puzzle Opens Today" />
      <StatCard value={puzzleSolves} label="Puzzle Solves Today" />
    </Box>
  );
};
